/** Hover copy when an explicit Save is disabled because nothing changed. */
export const HUB_SAVE_NO_CHANGES_HINT = "No changes to save.";

/**
 * Hover text for an explicit Save.
 * Permission / read-only copy wins over the no-changes hint.
 * When dirty, optional dirtyHint lists what will persist (enabled-button hover).
 * While a save is in flight, return null so the spinner is the only feedback.
 */
export function resolveHubSaveHoverHint(input: {
  dirty: boolean;
  isPending?: boolean;
  blockedHint?: string | null;
  dirtyHint?: string | null;
}): string | null {
  if (input.isPending === true) {
    return null;
  }
  const blocked = input.blockedHint?.trim() ?? "";
  if (blocked !== "") {
    return blocked;
  }
  if (!input.dirty) {
    return HUB_SAVE_NO_CHANGES_HINT;
  }
  const dirtyHint = input.dirtyHint?.trim() ?? "";
  return dirtyHint !== "" ? dirtyHint : null;
}

export function hubSaveButtonDisabled(input: {
  dirty: boolean;
  extraDisabled?: boolean;
  isPending?: boolean;
}): boolean {
  return input.extraDisabled === true || !input.dirty || input.isPending === true;
}
